import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, onMounted, ref } from "vue";
import filters from "@/core/helpers/filters";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceShow',
  props: {
    balance: { default: 0 },
    currencyId: { default: CurrencyTypes.USD }
  },
  setup(__props: any) {

const props = __props;

const language = useStore().state.AuthModule.user.language;

const currencyId = ref(props.currencyId);

const currencyShow = computed(() =>
  filters.toCurrency(props.balance, currencyId.value, language)
);

onMounted(() => {
  if (currencyId.value == -1) {
    currencyId.value = CurrencyTypes.USD;
  }
});

return (_ctx: any,_cache: any) => {
  return (currencyId.value != -1)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(currencyShow.value), 1))
    : _createCommentVNode("", true)
}
}

})